import React, { useState, useEffect } from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import { apiFetch } from '../utils/apiClient';

const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`); 

const FormulaireAdresse = ({ user }) => {
  const [isSubmitted, setIsSubmitted] = useState(false); // State to control popup
  const [message, setMessage] = useState("");
  const [couleur, setcouleur] = useState("");
  // const [typeLogement, setTypeLogement] = useState(""); 
  const location = useLocation();
  const [errors, setErrors] = useState({});
  let selectedForm = location.state?.selectedForm;
  const navigate = useNavigate(); // Initialize navigate hook

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-${yy}${mm}${dd}${randomNumber}-ADR`;
  };

  const initialFormData = {
    userId: "",
    nom: "",
    numeroFormulaire: generateNumeroFormulaire(),
    adressePostalResidentielle : selectedForm?.adressePostalResidentielle || "",
    adresse: selectedForm?.adresse || "",
    numeroappartement: selectedForm?.numeroappartement || "",
    ville: selectedForm?.ville || "",
    province: selectedForm?.province || "",
    codePostal: selectedForm?.codePostal || "",
    telephone: selectedForm?.telephone || "",
    telephoneCellulaire: selectedForm?.telephoneCellulaire || "",
    dateEntreeEnVigueur: selectedForm?.dateEntreeEnVigueur || "",
    etatDemande: "En attente",
    // traitant: {
    //   userId: "",
    //   nom: "",
    //   email: "",
    // },
    traitant: selectedForm?.traitant || [],
    dateSoumission: "",
  };
  // console.log("selected Form: ", selectedForm);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        courriel: user.mail,
        matricule: user.employeeId
      }));
    }

    if (selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        numeroFormulaire: selectedForm.numeroFormulaire, // Merge selectedForm data into formData
        
        boitePostale: selectedForm.boitePostale,
        appartementPostale: selectedForm.appartementPostale,
        villePostale: selectedForm.villePostale,
        provincePostale: selectedForm.provincePostale,
        codePostalPostale: selectedForm.codePostalPostale,
      }));
    }
  }, [user, selectedForm]); // Add selectedForm to the dependency array

  const handleChange = (e) => {
    const { name, value } = e.target;

    let newValue = value;

    if (name === "adresse" || name === "boitePostale") {
  // Extrait la partie chiffres + la suite
  const match = newValue.match(/^(\d*\s*)(.*)$/); // note le * au lieu de + pour accepter zéro chiffre
  if (match) {
    const digits = match[1]; // les numéros + espace, ou vide s'il n'y a pas de chiffres
    const rest = match[2]; // le texte après les numéros
    // Met la première lettre de "rest" en majuscule
    if (rest.length > 0) {
      newValue = digits + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      newValue = digits; // si rest est vide, on garde juste les chiffres
    }
  }
}


  // if (name === "adresse" || name === "boitePostale") {
  //   // Extrait la partie chiffres + la suite
  //   const match = newValue.match(/^(\d+\s*)(.*)$/);
  //   if (match) {
  //     const digits = match[1]; // les numéros + espace
  //     const rest = match[2]; // le texte après les numéros
  //     // Met la première lettre de "rest" en majuscule
  //     newValue = digits + rest.charAt(0).toUpperCase() + rest.slice(1);
  //   }
  // }

  if (name === "ville" || name === "villePostale") {
  // Supprime tout sauf lettres, accents, espaces et tirets
  newValue = newValue.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s-]/g, "");

  // Tout mettre en minuscule
  newValue = newValue.toLowerCase();

  // Majuscule à chaque début de mot (après espace ou tiret aussi)
  newValue = newValue.replace(/(?:^|\s|-)([a-zà-öø-ÿ])/g, (match) =>
    match.toUpperCase()
  );
}


    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
    setErrors("");
  };

  const handleFormAction = async (e, actionType) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    // Set the etatDemande based on the action type
    const updatedFormData = {
      ...formData,
      etatDemande: actionType, // Action type can be either "Soumettre" or "Enregistrer"
      dateSoumission: currentDate, // Send as a Date object
    };

    if(formData.adressePostalResidentielle==="oui" ){
      if(updatedFormData.boitePostale){
        updatedFormData.boitePostale = ""
      }
      if(updatedFormData.appartementPostale){
        updatedFormData.appartementPostale = ""
      }
      if(updatedFormData.villePostale){
        updatedFormData.villePostale = ""
      }
      if(updatedFormData.provincePostale){
        updatedFormData.provincePostale = ""
      }
      if(updatedFormData.codePostalPostale){
        updatedFormData.codePostalPostale = ""
      }
  }


    const method = location.state?.selectedForm ? "PUT" : "POST"; // Use PUT if selectedForm exists, otherwise POST
    const formType = "Adresse"; // Define form type
    const url = location.state?.selectedForm
      ? `${process.env.REACT_APP_API_BASE_URL}/form/${location.state.selectedForm._id}?form=${formType}` // Use the selectedForm ID to update
      : `${process.env.REACT_APP_API_BASE_URL}/form?form=${formType}`; // Use POST for creating a new form

    // console.log(updatedFormData);

    // Send the form data to the backend
    try {
      const response = await apiFetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFormData),
      });

      if (response.ok) {
        if(updatedFormData.etatDemande === "En attente"){
          if (socket) {
          socket.emit("requestUpdated");
        }
        }
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 2000);
        });
        const initialFormData = {
          nom: user.displayName,
          userId: user.id,
          numeroFormulaire: generateNumeroFormulaire(),
          adresse:  "",
          numeroappartement: "",
          ville: "",
          province: "",
          codePostal: "",
          telephone: "",
          telephoneCellulaire: "",
          dateEntreeEnVigueur: "",
          etatDemande: "En attente",
          // traitant: {
          //   userId: "",
          //   nom: "",
          //   email: "",
          // },
          traitant:[],
          dateSoumission: "",
        };
        setFormData(initialFormData);

        navigate("/demande", { state: { selectedForm: null } });
         
        // console.log(`Form data ${actionType.toLowerCase()} successfully!`);
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return; // Stop if validation fails
    handleFormAction(e, "En attente");
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
  };

  const handleSave = (e) => {
    handleFormAction(e, "Brouillon"); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis."
    );
    setcouleur("text-grey-600");
    setErrors("");
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.adresse.trim()) {
      newErrors.adresse = "L'adresse est obligatoire.";
    }
    if (!formData.ville.trim()) {
      newErrors.ville = "La ville est obligatoire.";
    }
    if (!formData.province.trim()) {
      newErrors.province = "La province est obligatoire.";
    }
    if (!/^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/.test(formData.codePostal.trim())) {
      newErrors.codePostal = "Le code postal doit être au format A1A 1A1.";
    }
    if (formData.telephone.trim().length < 10) {
      newErrors.telephone = "Le numéro de téléphone invalide";
    }
    if (formData.telephoneCellulaire.trim().length >= 1 && formData.telephoneCellulaire.trim().length < 10) {
      newErrors.autreTelephone = "Le numéro de téléphone doit contenir 10 chiffres.";
    }
    if (!formData.dateEntreeEnVigueur) {
      newErrors.dateEntreeEnVigueur = "La date est obligatoire.";
    }
    if(!formData.adressePostalResidentielle){
      newErrors.adressePostalResidentielle = "Veuillez sélectionner une option.";
    }

    if(formData.adressePostalResidentielle==="non"){
      if(!formData.boitePostale){
        newErrors.boitePostale = "L'adresse est obligatoire.";
      }
      if(!formData.villePostale){
        newErrors.villePostale = "La ville est obligatoire.";
      }
      if(!formData.provincePostale){
        newErrors.provincePostale = "La province est obligatoire.";
      }
      if(!/^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/.test(formData.codePostal)){
        newErrors.codePostalPostale = "Le code postal doit être au format A1A 1A1.";
      }
    }
    // Add other validations if necessary

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p style={{ color: "red" }}>{errors[field]}</p>
    ) : null;
  };

  /************************** Handle Inputs *******************************/
  const provinces = [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "ON",
    "PE",
    "QC",
    "SK",
    "NT",
    "NU",
    "YT",
  ];
  const handlePostalCodeChange = (e) => {
    let value = e.target.value;

    // Remove any invalid characters (allow only letters, numbers, and space)
    value = value.replace(/[^A-Za-z0-9 ]/g, "");

    // Ensure the space comes after the third character
    if (value.length > 3 && value[3] !== " ") {
      value = value.slice(0, 3) + " " + value.slice(3);
    }

    // Limit the input to 7 characters (XXX XXX format)
    if (value.length > 7) {
      value = value.slice(0, 7);
    }

    // Update the state with the corrected postal code value (uppercase)
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: value.toUpperCase(),
    }));

    setErrors("");
  };

  const handlePhoneNumberChange = (e) => {
    let value = e.target.value;

    // Remove any non-numeric characters (allow only digits)
    value = value.replace(/[^0-9]/g, "");

    // Limit the phone number to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Update the state with the phone number
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: value,
    }));

    setErrors("");
  };

  const handleClear = () => {
    // setFormData(initialFormData); // Réinitialise le formulaire à son état initial
    if (user) {
      setFormData((prevData) => ({
        ...prevData,
        nom: user.displayName,
        userId: user.id,
        typeLgt:  "",
        numApt: "",
        numRue:  "",
        adresse: "", // Use selectedForm data if available
        ville: "",
        province: "",
        codePostal: "",
        telephone: "",
        telephoneCellulaire: "",
        dateEntreeEnVigueur: "",
        etatDemande: "En attente",
        dateSoumission: "",
      }));
    }
    setErrors("");
  };
  /************************************************************************/

  return (
    <div className="min-h-screen p-8 bg-white rounded-lg shadow-lg" >
      <form
        onSubmit={handleSubmit}
        className=" p-8 bg-gray-100 rounded-lg shadow-lg"
      >
        <h1 className="text-2xl font-bold mb-6 text-black">
          Formulaire changement d'adresse
        </h1>
        <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
          <div className="w-[45%]">
            <label
              htmlFor="nom"
              className="block text-sm font-medium text-blue-900"
            >
              Nom:
            </label>
            <input
              type="text"
              id="nom"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              required
              disabled
            className="mt-1 p-3 w-full  border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>

          <div className="w-[45%]  sm:ml-auto">
            <label
              htmlFor="numeroFormulaire"
              className="block text-sm font-medium text-blue-900"
            >
              Numéro de formulaire:
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              name="numeroFormulaire"
              value={formData.numeroFormulaire}
              onChange={handleChange}
              required
              disabled
            className="mt-1 p-3 w-full  border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"            />
            
          </div>
        </div>
        <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">

          <div className="w-3/5">
  <label
    htmlFor="adressePostalResidentielle"
    className="block text-sm font-semibold text-gray-800 mb-1"
  >
    Votre adresse postale est-elle la même que votre adresse résidentielle ? <span className="text-red-500">*</span> :
  </label>

  <div className="mt-2 flex space-x-3">
    {["oui", "non"].map((option) => {
      const isSelected = formData.adressePostalResidentielle === option;
      return (
        <label
          key={option}
          className={`cursor-pointer px-3 py-1 text-sm rounded-md border transition-colors duration-150
            ${isSelected ? "bg-blue-600 text-white border-blue-600" : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"}`}
        >
          <input
            type="radio"
            name="adressePostalResidentielle"
            value={option}
            onChange={handleChange}
            className="hidden"
          />
          {option.charAt(0).toUpperCase() + option.slice(1)}
        </label>
      );
    })}
  </div>

  {renderError("adressePostalResidentielle")}
</div>

        </div>
        
        {formData.adressePostalResidentielle === "non" && (
          <div className="mt-8 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-3/5">
              <p className="block text-md font-bold text-blue-950">
                Adresse Résidentielle 
              </p>
            </div>
          </div>)}

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Adresse (#, rue)<span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="adresse"
              name="adresse"
              value={formData.adresse}
              onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("adresse")}
          </div>

          <div className="w-3/5">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-blue-900"
            >
              Adresse (# d'appartement):
            </label>
            <input
              type="text"
              id="numeroappartement"
              name="numeroappartement"
              value={formData.numeroappartement}
              onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
          <div className="w-3/5">
            <label
              htmlFor="ville"
              className="block text-sm font-medium text-blue-900"
            >
              Ville<span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="ville"
              name="ville"
              value={formData.ville}
              onChange={handleChange}
              onKeyPress={(e) => {
                const regex = /^[a-zA-ZÀ-ÿ-]$/; // lettres, accents et tirets seulement
                if (e.key !== " " && !regex.test(e.key)) {
                  e.preventDefault(); // empêche la saisie si ce n'est pas valide
                }
              }}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("ville")}
          </div>
          <div className="w-3/5 grid grid-cols-2">
            <div className="">
              <label
                htmlFor="province"
                className="block text-sm font-medium text-blue-900"
              >
                Province<span className="text-xl text-red-900" >*</span>:
              </label>
              <select
                id="province"
                name="province"
                value={formData.province}
                onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              >
                <option value="">Sélectionner</option>
                {provinces.map((province) => (
                  <option key={province} value={province}>
                    {province}
                  </option>
                ))}
              </select>
              {renderError("province")}
            </div>

            <div className="pl-2">
              <label
                htmlFor="codePostal"
                className="block text-sm font-medium text-blue-900"
              >
                Code Postal<span className="text-xl text-red-900" >*</span>:
              </label>
              <input
                type="text"
                id="codePostal"
                name="codePostal"
                value={formData.codePostal}
                onChange={handlePostalCodeChange}
                maxLength={7}
                placeholder="A1A 1A1"
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
              {renderError("codePostal")}
            </div>
          </div>
        </div>

        {formData.adressePostalResidentielle === "non" && (
          <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-3/5">
              <p className="block text-md font-bold text-blue-950">
                Adresse Postale
              </p>
            </div>
          </div>)}

        {formData.adressePostalResidentielle === "non" && (
          <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-3/5">
              <label
                htmlFor="boitePostale"
                className="block text-sm font-medium text-blue-900"
              >
                Adresse (#, rue) / Boite postale <span className="text-xl text-red-900" >*</span>:
              </label>
              <input
                type="text"
                id="boitePostale"
                name="boitePostale"
                value={formData.boitePostale}
                onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
              {renderError("boitePostale")}
            </div>

            <div className="w-3/5">
              <label
                htmlFor="appartementPostale"
                className="block text-sm font-medium text-blue-900"
              >
                Appartement / unité :
              </label>
              <input
                type="text"
                id="appartementPostale"
                name="appartementPostale"
                value={formData.appartementPostale}
                onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
            </div>
          </div>)}

        {formData.adressePostalResidentielle === "non" && (  
          <div className="mt-5 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-3/5">
              <label
                htmlFor="villePostale"
                className="block text-sm font-medium text-blue-900"
              >
                Ville<span className="text-xl text-red-900" >*</span>:
              </label>
              <input
                type="text"
                id="villePostale"
                name="villePostale"
                value={formData.villePostale}
                onChange={handleChange}
                onKeyPress={(e) => {
                  const regex = /^[a-zA-ZÀ-ÿ-]$/; // lettres, accents et tirets seulement
                  if (e.key !== " " && !regex.test(e.key)) {
                    e.preventDefault(); // empêche la saisie si ce n'est pas valide
                  }
                }}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
              {renderError("villePostale")}
            </div>
            <div className="w-3/5 grid grid-cols-2">
              <div className="">
                <label
                  htmlFor="provincePostale"
                  className="block text-sm font-medium text-blue-900"
                >
                  Province<span className="text-xl text-red-900" >*</span>:
                </label>
                <select
                  id="provincePostale"
                  name="provincePostale"
                  value={formData.provincePostale}
                  onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                >
                  <option value="">Sélectionner</option>
                  {provinces.map((province) => (
                    <option key={province} value={province}>
                      {province}
                    </option>
                  ))}
                </select>
                {renderError("provincePostale")}
              </div>

              <div className="pl-2">
                <label
                  htmlFor="codePostalPostale"
                  className="block text-sm font-medium text-blue-900"
                >
                  Code Postal<span className="text-xl text-red-900" >*</span>:
                </label>
                <input
                  type="text"
                  id="codePostalPostale"
                  name="codePostalPostale"
                  value={formData.codePostalPostale}
                  onChange={handlePostalCodeChange}
                  maxLength={7}
                  placeholder="A1A 1A1"
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                />
                {renderError("codePostalPostale")}
              </div>
            </div>
          </div>)}
     

        <div className="mt-8 w-3/4 grid grid-cols-2 gap-0 ">
          <div className="w-3/5">
            <label
              htmlFor="telephone"
              className="block text-sm font-medium text-blue-900"
            >
            Numéro de téléphone principal <span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="text"
              id="telephone"
              name="telephone"
              // value={formData.telephone}
              value={
                (() => {
                  const d = formData.telephone;
                  if (!d) return "";
                  let formatted = " ";
                  if (d.length <= 3) {
                    formatted += d;
                  } else if (d.length <= 6) {
                    formatted += d.slice(0, 3) + " " + d.slice(3);
                  } else {
                    formatted += d.slice(0, 3) + " " + d.slice(3, 6) + " " + d.slice(6);
                  }
                  
                  return formatted;
                })()
              }
              onChange={handlePhoneNumberChange}
              maxLength={13} // Maximum of 10 digits
              placeholder="123 456 7890"
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("telephone")}
          </div>

          <div className="w-3/5">
            <label
              htmlFor="telephoneCellulaire"
              className="block text-sm font-medium text-blue-900"
            >
            Autre numéro de téléphone (optionnel)<span className="text-xl text-red-900" ></span>:
            </label>
            <input
              type="text"
              id="telephoneCellulaire"
              name="telephoneCellulaire"
              // value={formData.telephoneCellulaire}
              value={
                (() => {
                  const d = formData.telephoneCellulaire;
                  if (!d) return "";
                  let formatted = " ";
                  if (d.length <= 3) {
                    formatted += d;
                  } else if (d.length <= 6) {
                    formatted += d.slice(0, 3) + " " + d.slice(3);
                  } else {
                    formatted += d.slice(0, 3) + " " + d.slice(3, 6) + " " + d.slice(6);
                  }
                  
                  return formatted;
                })()
              }
              maxLength={13}
              onChange={handlePhoneNumberChange}
              placeholder="123 456 7890"
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("autreTelephone")}
          </div>
        </div>

        <div className="mt-5 w-3/4 grid grid-cols-2 gap-0">
          <div className="w-1/2 ">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-blue-900"
            >
              Date d'entrée en vigueur<span className="text-xl text-red-900" >*</span>:
            </label>
            <input
              type="date"
              id="dateEntreeEnVigueur"
              name="dateEntreeEnVigueur"
              value={formData.dateEntreeEnVigueur}
              onChange={handleChange}
    className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            {renderError("dateEntreeEnVigueur")}
          </div>
        </div>

        {/* <div className="flex justify-center space-x-4">
          <button
            type="submit"
            className="mt-5 w-32 py-2  bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Soumettre
          </button>

          <button
            type="button" // Set type to "button" so it doesn't submit the form
            onClick={handleSave}
            className="mt-5 w-32 py-2 bg-gray-600 hover:bg-gray-400 text-white rounded-md"
          >
            Enregistrer
          </button>

          <button
            type="button" // Set type to "button" so it doesn't submit the form
            onClick={handleClear}
            className="mt-5 w-32 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md"
          >
            Réinitialiser
          </button>
        </div> */}

        <div className="flex justify-start mt-4">
          {/* Left-aligned Buttons */}
          <div className="flex space-x-4">
            {/* Save Button */}
            {/* Reset Button */}
            <button
              type="button"
              onClick={handleClear}
              className="mt-5 w-24 py-2 bg-red-600 hover:bg-red-400 text-white rounded-md "
            >
              Réinitialiser
            </button>
            {(selectedForm?.etatDemande !== "Rejeté") && (
            <button
              type="button"
              onClick={handleSave}
              className="mt-5 w-24 py-2 bg-gray-600 hover:bg-gray-400 text-white rounded-md"
            >
              Enregistrer
            </button>)}

            <button
              type="submit"
              className="mt-5 w-24 py-2 bg-green-600 text-white rounded-md hover:bg-green-400"
            >
              Soumettre
            </button>
          </div>
        </div>
      </form>
      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormulaireAdresse;
